// extracted by mini-css-extract-plugin
module.exports = {"user":"UserAvatar_user__2ce4c"};